import React from 'react';
import { Mountain, Bike, Fish, Leaf, MapPin } from 'lucide-react';
import { activities } from '../data/mock';

const iconMap = {
  mountain: Mountain,
  bike: Bike,
  fish: Fish,
  leaf: Leaf
};

export const Activities = () => {
  return (
    <section id="activities" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-emerald-100 rounded-full px-4 py-2 mb-4">
            <Mountain className="w-4 h-4 text-emerald-600" />
            <span className="text-sm font-semibold text-emerald-700">Adventure Awaits</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Explore the Welsh Mountains
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            From peaceful walks to adrenaline-pumping mountain biking, there's something for everyone.
          </p>
        </div>

        {/* Activities Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {activities.map((activity) => {
            const IconComponent = iconMap[activity.icon];
            return (
              <div
                key={activity.id}
                className="group bg-gradient-to-b from-emerald-50 to-white rounded-xl p-6 border border-emerald-100 hover:border-emerald-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="bg-emerald-600 w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:bg-emerald-700 group-hover:scale-110 transition-all">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {activity.name}
                </h3>
                {activity.distance && (
                  <div className="flex items-center space-x-1 text-emerald-600 text-sm font-medium mb-2">
                    <MapPin className="w-4 h-4" />
                    <span>{activity.distance}</span>
                  </div>
                )}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {activity.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Featured Activity Image */}
        <div className="mt-16 rounded-2xl overflow-hidden shadow-2xl">
          <div className="relative h-96">
            <img
              src="https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/6xhwj1ta_1000030877.png"
              alt="Llyn Clywedog Trout Fishery"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
              <div className="p-8 text-white">
                <h3 className="text-3xl font-bold mb-2">Llyn Clywedog Trout Fishery</h3>
                <p className="text-lg text-gray-200">
                  One of the UK's best fishing destinations, perfect for a peaceful day surrounded by stunning Welsh scenery.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
